import React, { useState } from 'react';
import { Divider, Flex } from 'antd';

import { MsTeamsTargetingClient, MSTeamsUser } from 'jf/api';
import { useDevExTheme } from 'jf/common/themes/DevExTheme';
import { DevExButton } from 'jf/components/DevExButton';
import { DevExDrawer } from 'jf/components/DevExDrawer';
import { useClientMutation } from 'jf/utils/useClientQuery';

import { MSTeamsSearchBar } from './MSTeamsSearchBar';
import { MSTeamsTargetList } from './MSTeamsTargetList';

type MSTeamsTargetDrawerProps = {
  open: boolean;
  onClose: () => void;
  msteamsUsers: MSTeamsUser[]; // from parent (study state)
  onDuplicateChange: (dupes: number) => void;
  addUsers: (users: MSTeamsUser[]) => void;
};

export const MSTeamsTargetDrawer: React.FC<MSTeamsTargetDrawerProps> = (props) => {
  const theme = useDevExTheme();
  const [msteamsUsers, setMsteamsUsers] = useState<MSTeamsUser[]>([]); // local to this drawer

  const { mutateAsync: expandMsteamsEntity, isLoading: isExpanding } = useClientMutation(
    MsTeamsTargetingClient.expandMsteamsEntity
  );

  return (
    <DevExDrawer
      title="Add people from Microsoft Teams"
      open={props.open}
      onClose={() => {
        setMsteamsUsers([]);
        props.onClose();
      }}
      width={640}
      closable
      extra={
        <Flex gap={theme.variable.spacing.sm}>
          <DevExButton
            onClick={() => {
              setMsteamsUsers([]);
              props.onClose();
            }}
          >
            Cancel
          </DevExButton>
          <DevExButton
            type="primary"
            onClick={() => {
              props.onDuplicateChange(
                msteamsUsers.filter((user) =>
                  props.msteamsUsers.some((target) => target.id === user.id)
                ).length
              );
              props.addUsers(
                msteamsUsers.filter(
                  (user) => !props.msteamsUsers.some((target) => target.id === user.id)
                )
              );
              setMsteamsUsers([]);
              props.onClose();
            }}
            disabled={msteamsUsers?.length === 0 ? true : false}
          >
            Add
          </DevExButton>
        </Flex>
      }
    >
      <Flex vertical gap={theme.variable.spacing.md}>
        <div>Add users by searching in MS Teams</div>
        <Flex justify="space-between" align="center">
          <MSTeamsSearchBar
            setSelectedMsteamsUsers={setMsteamsUsers}
            expandMsteamsEntity={expandMsteamsEntity}
          />
        </Flex>
        <Divider style={{ margin: `${theme.variable.spacing.sm} 0` }} />
        <MSTeamsTargetList
          users={msteamsUsers}
          onUpdate={setMsteamsUsers}
          emptyText="Start adding people from MS Teams by searching for them."
          trackEventKey="msteams-target-drawer"
          loading={isExpanding}
          loadingText="Adding people from MS Teams..."
        />
      </Flex>
    </DevExDrawer>
  );
};
